"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EternalDarknessAbilityHandler = exports.EternalDarknessActorAbilityFactory = exports.EternalDarknessAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class EternalDarknessAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.EternalDarkness;
        this.__typeName = "EternalDarkness";
    }
}
exports.EternalDarknessAbilityArgs = EternalDarknessAbilityArgs;
let EternalDarknessActorAbilityFactory = class EternalDarknessActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("EternalDarkness", "OneEnemies", 1);
    }
};
EternalDarknessActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("EternalDarkness")
], EternalDarknessActorAbilityFactory);
exports.EternalDarknessActorAbilityFactory = EternalDarknessActorAbilityFactory;
let EternalDarknessAbilityHandler = class EternalDarknessAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        const { applyCameraVfx, resetCameraVfx } = core_1.CameraVfxStepArgs.mkSequencesFor(core_1.CameraVfxStepArgs.Alpha(.5));
        sequence.push(applyCameraVfx.mk());
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Death", 100),
                AbilityDamage_1.AbilityDamage.Focus("Frost", 100)
            ],
            onHitOrMiss: (sequence, { hit }) => {
                sequence.push(new core_1.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet")
                    : LocationSelector_1.ActorVfxLocationSelector.Miss(selectedEnemy), "PurpleEvilMeteor"));
            },
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_2.LinkedEffectsEffectArgs([
                        new core_2.DarknessEffectArgs(),
                        new core_2.CurseEffectArgs("Focus", 10)
                    ], true)
                });
                const ruinated = container.readLocal(ability.invokerId, "Ruination_AppliedToId", 0);
                if (ruinated > 0) {
                    container.applyAttackDamage({
                        attackType: "magic_tick",
                        sequence,
                        attackerId: ability.invokerId,
                        targetId: ruinated,
                        isCrit: false,
                        toApply: AbilityDamage_1.AbilityDamage.Focus("Death", 100)
                    });
                }
            }
        });
        sequence.push(resetCameraVfx.mk());
    }
};
EternalDarknessAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.EternalDarkness)
], EternalDarknessAbilityHandler);
exports.EternalDarknessAbilityHandler = EternalDarknessAbilityHandler;
